import cookies from 'js-cookie';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { signInWithCustomToken, inMemoryPersistence } from 'firebase/auth';

import * as auth from 'endpoints/auth/client-via-auth-token';
import { sessionIn } from 'endpoints/auth';
import { ApiResponse } from 'endpoints/endpoint';
import { auth as firebaseAuth } from 'firebase-service/firebase-client';

export const signInWithToken = createAsyncThunk<
  ApiResponse<auth.SignInViaAuthTokenResult, auth.SignInViaAuthTokenError>,
  auth.SignInViaAuthTokenParams,
  { rejectValue: string }
>('client/signInWithToken', async (data, { rejectWithValue }) => {
  try {
    const csrfToken = cookies.get('__csrfToken');
    const response = await auth.signInWithToken(data, { 'x-csrf-token': csrfToken ?? '' }).invoke();
    const errorMessage = 'details' in response ? response.details : 'StopBroadcastError';

    if (response.success) {
      await firebaseAuth.setPersistence(inMemoryPersistence);
      await signInWithCustomToken(firebaseAuth, response.token);

      const idToken = await firebaseAuth.currentUser?.getIdToken(/* forceRefresh */ true);
      const csrfToken = cookies.get('__csrfToken');

      if (idToken && csrfToken) {
        await sessionIn({ idToken, scope: 'client' }, { 'x-csrf-token': csrfToken }).invoke();
        await firebaseAuth.signOut();

        return response;
      }
    }

    throw new Error(errorMessage);
  } catch (e) {
    return rejectWithValue((e as Error).message);
  }
});
